import axios from 'axios'

const Repository = axios.create()

export default Repository
